import React, { useState, useEffect } from 'react';
import {locationTexts} from '../contexts/LangCompany';

function CompanyLocation({ lang = 'ko' }) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return (
    <div
      style={{
        minHeight: '100vh',
        background: '#f5f6fa',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: isMobile ? '32px 16px' : '48px 16px'
      }}
    >
      <h1 style={{
        fontSize: isMobile ? '1.6rem' : '2rem',
        fontWeight: 700,
        color: '#29225C',
        marginBottom: 32,
        textAlign: 'center',
        padding: isMobile ? '0 20px' : '0'
      }}>
        <br />{locationTexts.Rimahr[lang]}
      </h1>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 24,
          width: isMobile ? '100%' : 800,
          maxWidth: isMobile ? 'calc(100% - 32px)' : 800,
          margin: '0 auto',
        }}
      >
        {/* 1번 박스: 구글 지도 */}
        <div
          style={{
            background: '#fff',
            borderRadius: 12,
            boxShadow: '0 1px 8px rgba(0,0,0,0.08)',
            padding: 0,
            overflow: 'hidden',
            minHeight: 160,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: isMobile ? '300px' : '480px',
            width: '100%',
            margin: '0 auto',
          }}
        >
          <iframe
            title="RIMAHR 위치"
            width="100%"
            height={isMobile ? "300" : "480"}
            frameBorder="0"
            style={{ border: 0, width: '100%', height: '100%' }}
            src="https://www.google.com/maps?q=서울특별시+영등포구+국회대로+62길+21+동성빌딩&output=embed"
            allowFullScreen
          />
        </div>
        {/* 2,3번 박스: 주소/연락처를 세로로 배치 */}
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 24,
            width: '100%',
            margin: '0 auto',
          }}
        >
          {/* 주소 박스 */}
          <div
            style={{
              background: '#fff',
              borderRadius: 12,
              boxShadow: '0 1px 8px rgba(0,0,0,0.08)',
              padding: isMobile ? '20px 24px' : '28px 36px',
              color: '#222',
              fontSize: isMobile ? '1rem' : '1.1rem',
              minHeight: 80,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'flex-start',
            }}
          >
            <div style={{ 
              fontWeight: 600, 
              marginBottom: 8,
              fontSize: isMobile ? '1.1rem' : '1.2rem'
            }}>{locationTexts.Address[lang]}</div>
            <div style={{ lineHeight: isMobile ? '1.5' : '1.4' }}>{locationTexts.AddressTxt[lang]}</div>
          </div>
          {/* 연락처 박스 */}
          <div
            style={{
              background: '#fff',
              borderRadius: 12,
              boxShadow: '0 1px 8px rgba(0,0,0,0.08)',
              padding: isMobile ? '20px 24px' : '28px 36px',
              color: '#222',
              fontSize: isMobile ? '1rem' : '1.1rem',
              minHeight: 80,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'flex-start',
            }}
          >
            <div style={{ 
              fontWeight: 600, 
              marginBottom: 8,
              fontSize: isMobile ? '1.1rem' : '1.2rem'
            }}>{locationTexts.Contact[lang]}</div>
            <div style={{ lineHeight: isMobile ? '1.6' : '1.4' }}>
              <div style={{ marginBottom: isMobile ? '4px' : '2px' }}>
                <strong>{locationTexts.Tel[lang]}</strong> {locationTexts.Teltext[lang]}
              </div>
              <div style={{ marginBottom: isMobile ? '4px' : '2px' }}>
                <strong>{locationTexts.Fax[lang]}</strong> {locationTexts.Faxtext[lang]}
              </div>
              <div>
                <strong>{locationTexts.eMail[lang]}</strong> {locationTexts.eMailtext[lang]}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CompanyLocation;